import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL:
    process.env.NODE_ENV == "production"
      ? "https://www.designyard.cn/api"
      : "https://www.designyard.cn/api",
  timeout: 10000 // 请求超时时间
})

let isTokenExpiredHandling = false

const isTokenExpiredCode = (code) => {
  return Number(code) === 401 || Number(code) === 402
}

const handleTokenExpired = () => {
  if (isTokenExpiredHandling) return

  isTokenExpiredHandling = true
  localStorage.removeItem('token')
  localStorage.setItem('loginAlert', 'true')
  window.location.href = window.location.origin
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 比如添加token
    const token = localStorage.getItem('token')
    // console.log(token ,'token')
    // const token = '74e3cff6ebdcd624a5ac397d453deb34'
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做些什么
    const res = response.data
    if (isTokenExpiredCode(res.code)) {
      handleTokenExpired()
      return Promise.reject(new Error(res.msg || '登录已过期，请重新登录'))
    }

    // 假设后端返回的格式是{ code: 200, data: {}, message: '' }
    if (res.code !== 200 && res.code !== 0) {
      // 处理错误情况
      console.error('响应错误:', res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    // 处理响应错误
    const response = error.response || {}
    const data = response.data || {}

    if (isTokenExpiredCode(response.status) || isTokenExpiredCode(data.code)) {
      handleTokenExpired()
    }

    console.error('响应错误:', data.msg || error.msg || error.message)
    return Promise.reject(error)
  }
)

export default service

// 用户模块API
export const user = {
  // 用户登录
  login: (data) => {
    return service.post('/login', data)
  },
  //验证码登录
  code_login: (data) => {
    return service.post('/code_login', data)
  },
  //邮箱登录
  email_login: (data) => {
    return service.post('/email_login', data)
  },
  //发送重置密码验证码
  send_reset_code: (data) => {
    return service.post('/send_reset_code', data)
  },
  //重置密码
  reset_password: (data) => {
    return service.post('/reset_password', data)
  },
  //修改密码（登录后）
  change_password: (data) => {
    return service.post('/change_password', data)
  },
  // 获取手机验证码
  sendCode: (data) => {
    return service.post('/sendCode', data)
  },
  // 用户注册
  register: (data) => {
    return service.post('/register', data)
  },
  //用户信息
  user_info: (data) => {
    return service.post('/user_info', data)
  },
  //普通会员信息编辑
  edit: (data) => {
    return service.post('/edit', data)
  },
  //设计师会员信息编辑
  edit_designer: (data) => {
    return service.post('/edit_designer', data)
  },
  //申请成为设计师
  apply_designer: (data) => {
    return service.post('/apply_designer', data)
  },
  //获取区域列表
  regions: (data) => {
    return service.post('/regions', data)
  },
  //获取收款人信息
  get_bank_info: (data) => {
    return service.post('/get_bank_info', data)
  },
  //获取支付方式
  payment_methods: (data) => {
    return service.post('/payment_methods', data)
  },
}

// 作品模块API
export const work = {
  //发表作品
  publish_work: (data) => {
    return service.post('/publish_work', data)
  },
  //获取作品列表
  get_work_list: (data) => {
    return service.post('/get_work_list', data)
  },
  //获取所有作品列表
  get_work_list_all: (data) => {
    return service.post('/get_work_list_all', data)
  },
  //获取作品详情
  get_work_detail: (data) => {
    return service.post('/get_work_detail', data)
  },
  //编辑作品
  edit_work: (data) => {
    return service.post('/edit_work', data)
  },
  //删除作品
  delete_work: (data) => {
    return service.post('/delete_work', data)
  },
}

//投稿模块API
export const draft = {
  //提交参展申请
  submit_annual_exhibition: (data) => {
    return service.post('/submit_annual_exhibition', data)
  },
  //获取投稿列表
  get_exhibition_works_list: (data) => {
    return service.post('/get_exhibition_works_list', data)
  },
  //获取参展申请详情
  get_annual_exhibition_detail: (data) => {
    return service.post(`/get_annual_exhibition_detail`, data)
  },
  //获取投稿详情
  get_exhibition_works_detail: (data) => {
    return service.post(`/get_exhibition_works_detail`, data)
  },
  //获取可投稿作品列表
  get_available_works: (data) => {
    return service.post('/get_available_works', data)
  },
  //获取年册筛选条件
  yearbook_filters: (data) => {
    return service.get('/yearbook_filters', data)
  },
  //获取设计师筛选条件
  designer_filters: (data) => {
    return service.get('/designer/filters', data)
  },
  //编辑投稿
  exhibition_works_edit: (data) => {
    return service.post('/exhibition_works_edit', data)
  },
}

// 订单模块API
export const order = {
  //创建订单
  create_order: (data) => {
    return service.post('/create_order', data)
  },
  //获取订单列表
  get_annual_exhibition_list: (data) => {
    return service.post('/get_annual_exhibition_list', data)
  },
  //获取订单列表
  get_order_list: (data) => {
    return service.post('/get_order_list', data)
  },
  //获取订单详情
  get_order_detail: (id) => {
    return service.post(`/get_order_detail/${id}`)
  },
  //微信支付
  wechat_pay: (data) => {
    return service.post(`/wechat_pay`, data)
  },
  //支付宝支付
  alipay_pay: (data) => {
    return service.post(`/alipay_pay`, data)
  },
  //线下支付（银行转账）
  offline_pay: (data) => {
    return service.post(`/offline_pay`, data)
  },
  //支付订单
  pay_order: (data) => {
    return service.post(`/pay_order`, data)
  },
  //取消订单
  cancel_order: (data) => {
    return service.post(`/cancel_order`, data)
  },
}

//上传文件API
export const upload = {
  //上传图片
  upload_image: (data) => {
    return service.post('/upload_image', data)
  },
  //上传头像
  upload_avatar: (data) => {
    return service.post('/upload_avatar', data)
  },
  //上传视频
  upload_video: (data) => {
    return service.post('/upload_video', data)
  },
  //删除已上传文件
  delete_file: (id) => {
    return service.post(`/delete_file/${id}`)
  },
}
